module.exports = __webpack_public_path__ + "img/digital_data.cf3a6df8.png";